/* MINIBIRK: readable labels on the theme's existing navigation controls. */
(() => {
  'use strict';

  const selector = '.swiper-button-prev, .swiper-button-next, .carousel__button.is-prev, .carousel__button.is-next, .n6pg li.prev a, .n6pg li.next a, .l4us .next-item, #totop a';
  const previousSelector = '.swiper-button-prev, .carousel__button.is-prev, .n6pg li.prev a';
  const copy = {
    sv: { previous: 'Föregående', next: 'Nästa', top: 'Upp' },
    en: { previous: 'Previous', next: 'Next', top: 'Top' },
    no: { previous: 'Forrige', next: 'Neste', top: 'Opp' },
    nb: { previous: 'Forrige', next: 'Neste', top: 'Opp' },
    nn: { previous: 'Forrige', next: 'Neste', top: 'Opp' },
    da: { previous: 'Forrige', next: 'Næste', top: 'Op' }
  };

  function syncGallery(gallery) {
    if (!gallery) return;
    const active = gallery.querySelector('.swiper-slide-active');
    const counter = gallery.querySelector('.swiper-pagination-current');
    const position = active && (active.getAttribute('aria-label') || '').match(/^([0-9]+)[ ]*[/][ ]*([0-9]+)$/);
    if (counter && position && counter.textContent !== position[1]) counter.textContent = position[1];
  }

  function labelControl(control) {
    const language = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    const words = copy[language] || copy.en;
    const text = control.matches('#totop a') ? words.top : control.matches(previousSelector) ? words.previous : words.next;
    let label = Array.from(control.children).find(child => child.classList.contains('mb-control-label'));
    let original = Array.from(control.children).find(child => child.classList.contains('mb-control-original'));
    const oldNodes = Array.from(control.childNodes).filter(node => node !== label && node !== original);

    // Keep original nodes and their listeners, while avoiding duplicate text or icons.
    if (oldNodes.length) {
      if (!original) {
        original = document.createElement('span');
        original.className = 'mb-control-original';
        original.hidden = true;
        original.setAttribute('aria-hidden', 'true');
      }
      oldNodes.forEach(node => original.appendChild(node));
      if (original.parentNode !== control) control.insertBefore(original, label || null);
    }
    if (!label) {
      label = document.createElement('span');
      label.className = 'mb-control-label';
      label.setAttribute('aria-hidden', 'true');
      control.appendChild(label);
    }
    if (label.textContent !== text) label.textContent = text;
    if (control.getAttribute('aria-label') !== text) control.setAttribute('aria-label', text);
    control.classList.add('mb-text-control');
    if (control.matches('.mb-product-page .l4pr .swiper-button-nav')) {
      control.setAttribute('role', 'button');
      const pager = control.closest('.swiper-custom-pagination');
      const thumbs = pager && pager.querySelector('.swiper-pagination-bullets');
      if (thumbs && pager.firstElementChild !== thumbs) pager.prepend(thumbs);
      syncGallery(control.closest('.l4pr'));
      if (!control.hasAttribute('data-mb-gallery-keyboard')) {
        control.setAttribute('data-mb-gallery-keyboard', 'ready');
        control.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (control.getAttribute('aria-disabled') === 'true' || control.classList.contains('swiper-button-disabled')) return;
          control.click();
        }, true);
      }
    }
  }

  function collect(root, controls) {
    if (root.nodeType !== 1) return;
    if (root.matches(selector)) controls.add(root);
    root.querySelectorAll(selector).forEach(control => controls.add(control));
  }

  function start() {
    if (document.documentElement.hasAttribute('data-mb-arrow-labels')) return;
    document.documentElement.setAttribute('data-mb-arrow-labels', 'ready');
    document.querySelectorAll(selector).forEach(labelControl);

    // Sliders, lightboxes and paginated sections can create controls after load.
    // Only inspect added subtrees; ignore our own additions to avoid observer loops.
    new MutationObserver(records => {
      const controls = new Set();
      records.forEach(record => {
        if (record.type === 'attributes') {
          if (record.attributeName === 'role' && record.target.matches('.mb-product-page .l4pr .swiper-button-nav')) {
            if (record.target.getAttribute('role') !== 'button') controls.add(record.target);
          } else if (record.attributeName === 'class' && record.target.matches('.mb-product-page .l4pr .swiper-slide')) {
            syncGallery(record.target.closest('.l4pr'));
          }
          return;
        }
        if (record.target.nodeType === 1 && record.target.closest('.mb-control-original, .mb-control-label')) return;
        record.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.matches('.mb-control-label, .mb-control-original')) return;
          if (record.target.nodeType === 1 && record.target.matches(selector)) controls.add(record.target);
          collect(node, controls);
        });
      });
      controls.forEach(labelControl);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['role', 'class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
